import {useFormContext} from 'react-hook-form'

import {mapVerticalToDeliveryType} from '../utils/map-vertical-to-delivery-type'

export function useVerticalType() {
  const {watch} = useFormContext()
  const verticalName = watch('selected_submode')

  return {
    rawVertical: verticalName,
    mappedVertical: mapVerticalToDeliveryType(verticalName),
  }
}
